import React, { useState, useEffect }  from "react";
import { useQueryClient } from '@tanstack/react-query';
// import { useNavigate } from "react-router-dom";
import { FormProvider } from "react-hook-form";
import { Input, DateInput, Select, SortHeader} from "@components";
import { useGridList } from "@hooks";
import { post } from "@utils/axios_api";
//d
const Grid = () => {
  const {
      methods, data, isLoading, isError, error, watch, onSubmit, refetch
    } = useGridList();
  
  const [tableData, setTableData] = useState([]);
  const [editingCell, setEditingCell] = useState(null);

  useEffect(() => {
    if (data?.resultList) {
      const copied = data.resultList.map((item) => ({
        boardNum: item.boardNum,    
        title: item.title,
        writer: item.writer,
        content: item.content,
        createdAt: item.createdAt,
        isNew: false,     // 새로 추가된 항목인지 여부
        isEdited: false,  // 수정된 항목인지 여부
        isDeleted: false, // 삭제된 항목인지 여부
      }));
      setTableData(copied);
    }
  }, [data]);
  
  const handleCellChange = (rowId, field, value) => {
    setTableData((prev) =>
      prev.map((row) => {
        if (row.boardNum === rowId) {
          const isEditedFlag = row.isNew ? row.isNew : true;
          return { ...row, [field]: value, isEdited: isEditedFlag };
        }
        return row;
      })
    );
  };
  const handleCellDoubleClick = (rowId, field) => {
    setEditingCell({ rowId, field });
  };

  const exitEditMode = () => {
    setEditingCell(null);
  };

  const handleAddRow = () => {
    const newRow = {
      boardNum: `temp-${Date.now()}`,
      title: "",
      writer: "",
      content: "",
      isNew: true,
      isEdited: false,
      isDeleted: false,
    };
    setTableData((prev) => [...prev, newRow]);
  };

  const handleDeleteRow = (targetBoardNum) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    setTableData((prev) =>
      prev.map((row) => (row.boardNum === targetBoardNum ? { ...row, isDeleted: true } : row))
    );
  };

  const handleSave = async () => {
    if (!window.confirm("저장 하시겠습니까?")) return;

    const rawNewRows = tableData.filter((r) => r.isNew && !r.isDeleted);
    const editedRows = tableData.filter((r) => r.isEdited && !r.isNew && !r.isDeleted);
    const deletedRows = tableData.filter((r) => r.isDeleted && !r.isNew);

    const newRows = rawNewRows.map((row) => {
      const { boardNum, ...rest } = row;    
      return rest; 
    });

    const savePayload = {
      newRows, 
      editedRows, 
      deletedRows: deletedRows.map((d) => d.boardNum), 
    };

    try {

      const response = await post("/saveAll", savePayload);

      alert(response.message);

      refetch();
    } catch (error) {
      console.error("저장 중 오류:", error);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  if (isLoading) {
      return <div>로딩 중...</div>;
  }
  if (isError) {
      console.log("isError:", error);
      return <div>오류가 발생했습니다: {error?.message || "알 수 없는 에러"}</div>;
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>안전법규및규정</h2>
          </div>

          <div className="tab-wrap">
            <ul>
              <li id="tabBtn1" className="on"><a  title="산업안전보건법">산업안전보건법</a></li>
              <li id="tabBtn4"><a  title="안전보건관계법령">안전보건관계법령</a></li>
              <li id="tabBtn2"><a title="중대재해처벌법">중대재해처벌법</a></li>
              <li id="tabBtn3"><a  title="사내안전보건관리규정">사내안전보건관리규정</a></li>
            </ul>
          </div>

          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item date-picker-box">
                    <label>등록일</label>
                      <DateInput name="createStDate" />
                      <span className="separator">~</span>
                      <DateInput name="createEndDate" minDate={watch("createStDate")} />
                  </div>
                  <div className="search-item">
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "제목" },
                        { key: "1", name: "내용" },
                      ]}
                      defaultOption="선택"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "250px" }}
                    />
                  </div>
                  <div className="search-btn-container">
                    <button className="btn-search">조회</button>
                  </div>
                </div>
              </div>

                <section>
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;산업안전보건법
                      <span className="total-txt">
                        {" "} | 총 <span className="red">{data.totalCount}</span> 건
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button type="button" title="추가" className="btn-add" onClick={handleAddRow} >추가</button></li>
                        <li><button type="button" title="저장" className="btn-save" onClick={handleSave} >저장</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="grid-wrapper">
                    <div className="table-container grid-container" style={{ width: "100%", height: "700px", overflow: "auto" }}>
                      <table className="grid-list">
                        <colgroup>
                          <col style={{ width: "3%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "5%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "5%" }} />
                          <col style={{ width: "5%" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>번호</th>
                            <SortHeader field="TITLE" label="제목" />
                            <SortHeader field="WRITER" label="담당자" />
                            <SortHeader field="CONTENT" label="내용" />
                            <SortHeader field="CREATED_AT" label="등록일" />
                            <th>삭제</th>

                          </tr>
                        </thead>
                        <tbody>
                        {tableData.length > 0 ? (
                          tableData.filter((row) => !row.isDeleted).map((row, idx) => (
                              <tr key={row.boardNum}>
                                <td>{idx + 1}</td>

                                <td onDoubleClick={() => handleCellDoubleClick(row.boardNum, "title")}>
                                  {editingCell &&
                                  editingCell.rowId === row.boardNum &&
                                  editingCell.field === "title" ? (
                                    <input
                                      autoFocus
                                      value={row.title || ""}
                                      onChange={(e) => handleCellChange(row.boardNum, "title", e.target.value)}
                                      onBlur={exitEditMode}
                                    />
                                  ) : (
                                    <span>{row.title}</span>
                                  )}
                                </td>

                                <td onDoubleClick={() => handleCellDoubleClick(row.boardNum, "writer")}>
                                  {editingCell &&
                                  editingCell.rowId === row.boardNum &&
                                  editingCell.field === "writer" ? (
                                    <input
                                      autoFocus
                                      value={row.writer || ""}
                                      onChange={(e) => handleCellChange(row.boardNum, "writer", e.target.value)}
                                      onBlur={exitEditMode}
                                    />
                                  ) : (
                                    <span>{row.writer}</span>
                                  )}
                                </td>

                                <td onDoubleClick={() => handleCellDoubleClick(row.boardNum, "content")}>
                                  {editingCell &&
                                  editingCell.rowId === row.boardNum &&
                                  editingCell.field === "content" ? (
                                    <input
                                      autoFocus
                                      value={row.content || ""}
                                      onChange={(e) => handleCellChange(row.boardNum, "content", e.target.value)}
                                      onBlur={exitEditMode}
                                    />
                                  ) : (
                                    <span>{row.content}</span>
                                  )}
                                </td>

                                <td>{row.createdAt}</td>

                                <td>
                                  <button type="button" onClick={() => handleDeleteRow(row.boardNum)}>
                                    삭제
                                  </button>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "center" }}>
                              조회 결과가 없습니다.
                            </td>
                          </tr>
                        )}
                      </tbody>
                      </table>
                  </div>
                  {/* <div className="table-container grid-container" style={{ width: "75%", height: "600px", overflow: "auto" }}>
                      <table className="grid-list">
                        <colgroup>
                          <col style={{ width: "3%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "5%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "5%" }} />
                          <col style={{ width: "5%" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>번호</th>
                            <SortHeader field="TITLE" label="제목" />
                            <SortHeader field="WRITER" label="담당자" />
                            <SortHeader field="CONTENT" label="내용" />
                            <SortHeader field="CREATED_AT" label="등록일" />
                            <th>삭제</th>

                          </tr>
                        </thead>
                        <tbody>
                        {tableData.length > 0 ? (
                          tableData.filter((row) => !row.isDeleted).map((row, idx) => (
                              <tr key={row.boardNum}>
                                <td>{idx + 1}</td>

                                <td onDoubleClick={() => handleCellDoubleClick(row.boardNum, "title")}>
                                  {editingCell &&
                                  editingCell.rowId === row.boardNum &&
                                  editingCell.field === "title" ? (
                                    <input
                                      autoFocus
                                      value={row.title || ""}
                                      onChange={(e) => handleCellChange(row.boardNum, "title", e.target.value)}
                                      onBlur={exitEditMode}
                                    />
                                  ) : (
                                    <span>{row.title}</span>
                                  )}
                                </td>

                                <td onDoubleClick={() => handleCellDoubleClick(row.boardNum, "writer")}>
                                  {editingCell &&
                                  editingCell.rowId === row.boardNum &&
                                  editingCell.field === "writer" ? (
                                    <input
                                      autoFocus
                                      value={row.writer || ""}
                                      onChange={(e) => handleCellChange(row.boardNum, "writer", e.target.value)}
                                      onBlur={exitEditMode}
                                    />
                                  ) : (
                                    <span>{row.writer}</span>
                                  )}
                                </td>

                                <td onDoubleClick={() => handleCellDoubleClick(row.boardNum, "content")}>
                                  {editingCell &&
                                  editingCell.rowId === row.boardNum &&
                                  editingCell.field === "content" ? (
                                    <input
                                      autoFocus
                                      value={row.content || ""}
                                      onChange={(e) => handleCellChange(row.boardNum, "content", e.target.value)}
                                      onBlur={exitEditMode}
                                    />
                                  ) : (
                                    <span>{row.content}</span>
                                  )}
                                </td>

                                <td>{row.createdAt}</td>

                                <td>
                                  <button type="button" onClick={() => handleDeleteRow(row.boardNum)}>
                                    삭제
                                  </button>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "center" }}>
                              조회 결과가 없습니다.
                            </td>
                          </tr>
                        )}
                      </tbody>
                      </table>
                    </div> */}
                  </div>
                </section>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export {Grid};
